<template>
	<a-layout-sider  class="mainLeftSider2">
	  <div class="itemListDiv" :style="{height:'100vh'}"  :title="leftHieght">
		   <h2 class="left-title">查找</h2>
		   <div class="search-min2">
			   <a-input-search placeholder="搜索..." allow-clear  v-model="keywordsVal" @input="handleSearch" />
		   </div>
		   <div class="menu-div" :style="{height:dynamicHeight + 'px'}"> 
			   <div class="scroll-container" @scroll="handleScroll">
			    
			   	   <template v-for="(item, index) in listData"> 
			   		   <template v-if="(seltArtItem.id==item.id||seltArtItem2.id==item.id) "  >
			   				<a-row :gutter="8" :key="index" class="detailList active">
			   					<a-col class="img-cls" :span="3">
			   						<img  :src="'/assets/img/main/icon-'+item.file_url_type+'.png'"   />
			   					</a-col>
			   					<a-col class="content" :span="21" @click="toDetail(item.id)" >
			   						<h4  class="title" ><a :data-h="item.height">{{item.title}}</a></h4>
			   						<span class="description" v-if="item.desc!=''">{{item.desc}}</span>
			   					</a-col>
			   				</a-row>						   
			   		   </template>
			   		   <template v-else-if="item.id > 0">
			   				<a-row :gutter="8" :key="index" class="detailList">
			   					<a-col class="img-cls" :span="3">
			   						<img  :src="'/assets/img/main/icon-'+item.file_url_type+'.png'"   />
			   					</a-col>
			   					<a-col class="content" :span="21" @click="toDetail(item.id)" >
			   						<h4 class="title" ><a :data-h="item.height">{{item.title}}</a></h4>
			   						<span class="description" v-if="item.desc!=''">{{item.desc}}</span>
			   					</a-col>
			   				</a-row>
			   		   </template>
			   			<template  v-else-if=" isEnd==true && item.id==0 "  >								
			   				<a-row :key="index" :style="{ height: '60px' }" class="nomorelist">
			   					<a-col :span="24">
			   						没有更多了
			   					</a-col> 
			   				</a-row>								
			   			</template>
			   			
			   	  </template>
			   	  <p style="text-align: center;"><a-spin v-if="loading" class="demo-loading" /></p>
			   </div>
			   
			   
		   </div>
			
			
	  </div>
	</a-layout-sider>
</template>

<script>
	//const GListData = [];
	import _ from 'lodash';
	import {getArtItem,getSizeHieght,quChongArr} from '@/utils/util';
	
	import infiniteScroll from 'vue-infinite-scroll';
	//import { RecycleScroller } from 'vue-virtual-scroller';
	import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
	
	export default {
	  directives: { infiniteScroll },
	  components: {
		  //RecycleScroller,
	  },
	  data() {
	    return { 
			keywordsVal:"",
	        listData:[], 
		   
		   CurPage:0,
		   pagination: {
		     onChange: page => {
				console.log(page);
		     },
		     total:0,
		     pageSize:15,
		     size:'small',
		   },
		   loading: false,
		   busy: false,
		   
		   screenHeight: 0,
		   windowWidth:0,
		   dynamicHeight:300,
		   leftHieght:0,
		
		   itemSizeHeight:90,
		   swipedDirection:"down", 
		   
		   seltId:0,
		   seltId2:0,
		   lastpage:0,
		   isEnd:false,
	    };
	  },
	  computed: { 
		  // listDataVal(){
			 //  return this.$store.state.article.resDataSearch;
		  // },
		  LeftHieghtVal(){
			  return this.$store.state.article.leftHieght;
		  },
		  seltMenuItemVal(){
			  return this.$store.state.article.seltMenuItem;
		  },
		  isFenPingVal(){
			  return this.$store.state.article.isFenPing; 
		  },
		  computedMinHeight() {
			  console.log("computedMinHeight-------------",this.$route.path);
		      return this.$route.path === '/detail' ? 50 : 90 // 根据路由动态调整
		  },
		  seltArtItem(){
			   return this.$store.state.article.seltArtItem;
		  },
		  seltArtItem2(){
			   return this.$store.state.article.seltArtItem2;
		  }
	  },
	  watch:{ 
		 //  listDataVal(newVal){
			// var _self=this; 			
			// newVal=newVal.filter(item =>item.type !== 'dir' );
			// newVal=newVal.filter(item =>item.type !== 'list' );
			// var listData=quChongArr(_self.listData.concat(newVal),'id'); 
			// _self.listData=listData;			
			// _self.$store.commit("article/set_leftArtlist",_self.listData);
		 //  },
		  LeftHieghtVal(newVal){
			this.leftHieght=newVal;
		  },
		  isFenPingVal(newVal){
			  this.isFenPing=newVal;
		  },
		  windowWidth(newVal){
			  this.itemSizeHeight=getSizeHieght(newVal);
		  }
	  },
	  created() {	
		this.handleSearch = this.handleSearch.bind(this); // 确保handleSearch中的this指向Vue实例
		this.seltId=this.$route.query.id;
		console.log(this.seltId);		
		
		this.$store.commit("article/set_leftArtlist",[]);
	  },	 
	  beforeMount() {
		 var listData=this.$store.state.article.resDataSearch;
		 
		 listData=listData.filter(item =>item.type !== 'dir' );
		 listData=listData.filter(item =>item.type !== 'list' );
		 this.listData=listData;//.filter(item =>(item.type !== 'dir' || item.type !== 'list'));
	  },
	  mounted() {
		this.updateScreenHeight();
		window.addEventListener('resize', this.updateScreenHeight);
		
		this.itemSizeHeight=getSizeHieght(this.windowWidth);
		console.log("this.itemSizeHeight:",this.itemSizeHeight);
		this.$store.commit("article/set_historyId",[]);
		// 初始化时绑定handleSearch到组件实例上，确保在组件销毁时取消防抖函数
		this.handleSearch = _.debounce(this.performSearch, 500);
		
		var historyIdArr=[];
		var arr={div1:[{id:this.seltArtItem.id,title:this.seltArtItem.title}],div2:[]};
		historyIdArr=arr;
		this.$store.commit("article/set_historyId",historyIdArr);
		console.log("historyIdArr:",historyIdArr);
		
		
		var _self=this;
		_self.handleInfiniteOnLoad();
			
	  },
	  methods: {  
		  
		  handleScroll(event) {
		  			const { scrollTop, clientHeight, scrollHeight } = event.target;
		  			if (scrollTop + clientHeight >= scrollHeight) {
		  			  console.log('已滚动到底部');
		  			  // 执行加载更多等操作
		  			  this.handleInfiniteOnLoad();
		  			  
		  			}
		  },
		  handleInfiniteOnLoad(){
			//加载更多
			var _self=this;
			const data = this.listData;
			if(this.loading==true)
			{
				return;
			}
			
			if(_self.isEnd==true)
			{
				return;//已到底 
			}
			
			this.loading = true;
			if (data.length > 100) 
			{
			  this.$message.warning('Infinite List loaded all');
			  this.busy = true;
			  this.loading = false;
			  return;
			}
			var params={
				id:0,
				page:0,
				pageSize:100,//this.$store.state.article.pageSize, 
				key:this.$store.state.article.searchKeyWordsTop,
				istype:"curpage-detail"
			};
			
			setTimeout(function(){
				_self.CurPage=_self.CurPage+1;
				params.page=_self.CurPage;
				params.istype="curpage-detail";				
				
				_self.$store.dispatch("article/GetGlobalSearch2",params).then(res=>
				{
					_self.CurPage=res.datas.current_page;
					_self.lastpage=res.datas.last_page;
					
					var listData=_self.listData; 
					var clist=res.datas.data;
					for(var i=0;i<clist.length;i++)
					{
						var row=clist[i];
						listData.push(row);
					}
					_self.listData=quChongArr(listData,'id');
					_self.listData=listData;
						
					if(_self.CurPage>_self.lastpage)
					{
						//_self.$message.error("没有更多了");
						var item={id:0,article_id:0};
						listData=_self.listData; 
						if(_self.isEnd==false)
						{
							listData.push(item);
							_self.listData=listData;
						}
						_self.isEnd=true;
						console.log("没有更多了");
					}
					_self.$store.commit("article/SetResDataDetail",_self.listData);
					_self.loading = false; 
					
				}); //当前页
									 
				//_self.listData=_self.$store.state.article.resData;
				
			},1000);
			
		  },
		//小类查找
		 handleSearch: _.debounce(function() {
			  this.performSearch();	  
		 },800), // 延迟500毫秒执行搜索操作
		 
		 performSearch() 
		 {
		 	//console.log(value);
		 	var _self=this;
		 	var keywords=_self.keywordsVal.trim();
		 	console.log('Search query:', keywords);
		 	if(keywords.length>0)
		 	{ 
		 		this.$store.commit("article/SetSearchKeyWordsMin",keywords.trim());
				this.listData=[];
				//_self.keywordsVal="";
		 		var params={
		 		  id:0,
		 		  page:1,
		 		  pageSize:100,//_self.$store.state.article.pageSize,
		 		  key:keywords
		 		};
		 		var cparmas=params;
		 		cparmas.istype="curpage";
		 		_self.$store.dispatch("article/GetGlobalSearch2",cparmas).then(res=>{
						_self.CurPage=res.datas.current_page;
						_self.lastpage=res.datas.last_page;
						
						var listData=_self.listData; 
						var clist=res.datas.data;
						for(var i=0;i<clist.length;i++)
						{
							var row=clist[i];
							listData.push(row);
						}
						_self.listData=quChongArr(listData,'id');
						_self.listData=listData;
							
						if(_self.CurPage>_self.lastpage)
						{
							//_self.$message.error("没有更多了");
							var item={id:0,article_id:0};
							listData=_self.listData; 
							if(_self.isEnd==false)
							{
								listData.push(item);
								_self.listData=listData;
							}
							_self.isEnd=true;
							console.log("没有更多了");
						}
						_self.$store.commit("article/SetResDataDetail",_self.listData);
						
					}); //当前页
		 	}
		 },
		 
		 
		 
		 
	   updateScreenHeight() {
			this.screenHeight = window.innerHeight;
		  	this.windowWidth = window.innerWidth; 
		  	console.log("showLoading------------windowWidth:",this.windowWidth);
			this.dynamicHeight=this.screenHeight * 0.75;
		  },
		EmptyDataSendToMain(key){
			// 假设我们要传递的数据是'some data'
			//this.$emit('custom-event', key);//this.$emit('事件名',要传的数据)
		},
		toDetail(data){
			 var id=data;
			 //this.seltId=id;
			 //console.log(this.seltId);		
			 //console.log("left-id:",id);
			 var resData=this.listData;
			 var seltArtItem=getArtItem(resData,id);
			 //this.$emit('todetail-event',seltArtItem);//this.$emit('事件名',要传的数据)		
			 var activeDivId= this.$store.state.article.activeDetailContent;	
			 var historyIdArr= this.$store.state.article.historyId;	
			 var arr={id:id,title:seltArtItem.title};
			 if(activeDivId=="div1")
			 {
				historyIdArr.div1.push(arr);
			 }
			 else
			 {
				historyIdArr.div2.push(arr);
			 }
			 this.$store.commit("article/set_historyId",historyIdArr);
			 //console.log("historyIdArr:",historyIdArr);
			 
			 if(this.isFenPingVal==true)
			 {
				 //分屏		
				 var activeVal1=this.$store.state.article.seltArtItem;
				 var activeVal2=this.$store.state.article.seltArtItem2;	
				 //console.log("dblclick---activeVal1：",activeVal1);	 
				 //console.log("dblclick---activeVal2：",activeVal2);	 
				  if(activeDivId=="div1")
				 { 
				 	this.$store.commit("article/set_seltArtItem",seltArtItem);		 
				 	//console.log("dblclick1---",seltArtItem.name);
				 }
				 if(activeDivId=="div2"){
				 	this.$store.commit("article/set_seltArtItem2",seltArtItem);		 
				 	//console.log("dblclick2---",seltArtItem);
				 }
				 
				 
			 }
			 else
			 {		
				 console.log("当前激活状态的窗口：",activeDivId);
				 if(activeDivId=="div1")
				 { 
				 	this.$store.commit("article/set_seltArtItem",seltArtItem);	
				 }
				 if(activeDivId=="div2"){
				 	this.$store.commit("article/set_seltArtItem2",seltArtItem);		
				 } 
			 }
		},
 
		onSearch(){
			return;
		}, 
	  },
	  beforeDestroy() {
		window.removeEventListener('resize', this.updateScreenHeight);
	  },
	  beforeRouteLeave(to, from, next) {
		console.log("beforeRouteLeave-------------------------");
	    this.$refs.scroller.$forceUpdate();
	    next()
	  }
	};
</script>

<style lang="scss" scoped>
	.mainLeftSider2{
		background-color: unset;
		width: 220px!important;min-width: 220px!important;max-width: 220px!important;
		.itemListDiv{
			float: right; width:200px;height: 699px;max-height: 87vh; background-color: #fff; border-radius:12px;
			padding-left:9px;padding-right: 10px; padding-top: 0px; padding-bottom: 12px; overflow: hidden;
			.left-title{
				font-size: 16px; line-height:20px;padding-top: 10px;padding-bottom: 10px; 
				font-weight: 600;color:rgba(25, 26, 26, 1); margin-bottom:4px;				
				text-overflow:ellipsis;
				white-space:nowrap;
				overflow: hidden; 
			}
			span,li{color: #000;}
			.ant-menu-item-selected{
				background-color:rgba(31, 110, 238, 1) ;color: #fff; border-radius: 10px;
			}
			
		}
		.detailList{
			border: solid 1px rgba(236, 236, 236, 1); border-radius:8px; 
			min-height:40px;
			padding:5px; padding-left: 5px;
			display: flex;
			width: 98%; 
			margin: 0px auto!important;
			margin-top: 8px!important;
			.img-cls{
				text-align: center;min-width: 20px;
				img{ width: 15px; margin: 0px auto; }
			}
			.content{
				max-width: 87%;
				h4{
					a{
						color: #000; 
						font-size: 14px; 
						font-weight: 600; 
						line-height: 22px;
						
						word-wrap: break-word;
						white-space:break-spaces;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 3;
						overflow: hidden;
					}
				} 
				h4.title{
					width: 100%;
				}
				.description{
					color: rgba(25, 26, 26, 1);  
					max-width: 95%;
					line-height: 22px;
					text-overflow:ellipsis;
					white-space:nowrap;
					overflow: hidden; 
					display: block;
				}
			}
		}
		// .detailList:hover,
		.detailList.active{
			background-color: rgba(237, 244, 255, 1);
		}
		.menu-div{ display: flow-root;width: 100%; overflow: hidden;}
		.nomore{
			width: 100%; height: 40px; 
			line-height: 40px; text-align: center; font-size: 14px;color:#aaa; 
			position: absolute;left:0px;bottom:-100px;transition:all 0.3s
		}
		.showDiv{bottom:0px; transition:all 0.3s}
		.nomorelist{ text-align: center;color:#999; line-height: 50px;}
	}
	.scroll-container {
	  height: 100%;
	  overflow-y: auto;
	}
	
</style>
<style> 
	.search-min2{ width: 98%; margin: 0px auto; }
	.search-min2 .ant-input{border-radius: 12px;border-color: #E2E3E7;}
	.detailList .ant-list-item-meta-avatar{margin-right:4px;padding-top:0px;}
	.demo-infinite-container {  
	  overflow: auto; 
	  height: 500;
	}
	.demo-loading-container {
	  position: absolute;
	  bottom: 40px;
	  width: 100%;
	  text-align: center;
	}
	/* .mainLeftSider2 .vue-recycle-scroller__item-wrapper{ min-height: 100px!important;} */
</style> 